// 起動: /config.json を読んでから描く。読めなければその旨だけ出す。
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { loadConfig } from './lib/config';
import { App } from './App';

const root = createRoot(document.getElementById('root')!);

loadConfig()
  .then(() =>
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    ),
  )
  .catch((e: Error) =>
    root.render(
      <div style={{ padding: 24 }} role="alert">
        {e.message}
      </div>,
    ),
  );
